import React, { useEffect, useMemo, useRef, useState } from "react";
import InfiniteMenu from "./InfiniteMenu";
import MatrixHeading from "./MatrixHeading";
import "./Memories.css";

const rawImages = [
  { src: "img1.webp", alt: "Riviera, IEEE TEMS Vellore", caption: "The Team" },
  { src: "img2.webp", alt: "Ice-Breaking, IEEE TEMS Vellore", caption: "Ice-Breaking" },
  { src: "img3.webp", alt: "Innovision, IEEE TEMS Vellore", caption: "HackXpertise 2.0" },
  { src: "img4.webp", alt: "Code Rush, IEEE TEMS Vellore", caption: "Expo Gravitas 2025" },
  { src: "img5.webp", alt: "Riviera, IEEE TEMS Vellore", caption: "Riviera" },
  { src: "img6.webp", alt: "Gravitas, IEEE TEMS Vellore", caption: "CodeRush 2.0" },
  { src: "img8.webp", alt: "Team 2022-23, IEEE TEMS Vellore", caption: "Squid Survivals" },
  { src: "img9.webp", alt: "Team 2022-23, IEEE TEMS Vellore", caption: "Expo Gravitas 2025" },
  { src: "img10.webp", alt: "Team 2022-23, IEEE TEMS Vellore", caption: "Team Moments" },
  { src: "img11.webp", alt: "Team 2022-23, IEEE TEMS Vellore", caption: "Bounty Castle" },
  { src: "img14.jpeg", alt: "HackXpertise 2.0, IEEE TEMS Vellore", caption: "HackXpertise 2.0" },
  { src: "img15.jpeg", alt: "Gravitas - HP Event, IEEE TEMS Vellore", caption: "Gravitas - HP Event" },
  { src: "img16.jpeg", alt: "Stranger Nights, IEEE TEMS Vellore", caption: "Stranger Nights" },
  { src: "img17.jpg", alt: "Riviera '26, IEEE TEMS Vellore", caption: "Riviera '26" },
  { src: "img18.png", alt: "Cultrix, IEEE TEMS Vellore", caption: "Cultrix" },
  { src: "img19.png", alt: "Riviera Expo '26, IEEE TEMS Vellore", caption: "Riviera Expo '26" },
  { src: "img20.jpg", alt: "Riviera Expo '26, IEEE TEMS Vellore", caption: "Riviera Expo '26" },
  { src: "img21.png", alt: "Riviera Expo '26, IEEE TEMS Vellore", caption: "Riviera Expo '26" },
];

const Memories = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.25 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  /* Map our existing assets into the shape InfiniteMenu expects:
     { image, link, title, description }. Memoized so the InfiniteMenu
     effect doesn't re-init the WebGL context on every render. */
  const items = useMemo(
    () =>
      rawImages.map((img) => ({
        image: process.env.PUBLIC_URL + "/" + img.src,
        link: "",
        title: img.caption || "IEEE TEMS",
        description: img.alt,
      })),
    [],
  );

  return (
    <section id="Memories" ref={sectionRef}>
      <div className="mem-split">
        {/* LEFT — title block (mirrors About Us) */}
        <div className="mem-left">

          <h2 className="mem-main-heading">
            <MatrixHeading text="Memories" active={isVisible} />
          </h2>

          <p className="mem-tagline">
            <span className="mem-tagline-row">MOMENTS</span>
            <span className="mem-tagline-row">WE CHERISH</span>
          </p>

          <div className="mem-heading-line" />

          <p className="mem-desc">
            Snapshots from our events, workshops and the people who make
            IEEE TEMS VIT what it is. Drag the sphere to relive a moment.
          </p>

          <p className="mem-mission-text">
            Every face here is part of our story.
          </p>
        </div>

        {/* RIGHT — interactive sphere of memories */}
        <div className="mem-right">
          <div className="memories-canvas-wrap">
            {/* soft glow backdrop so the globe pops off the background */}
            <div className="mem-sphere-glow" />
            <InfiniteMenu items={items} scale={0.72} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Memories;
